export const unities: { [key: string]: string}  = {
  liter: 'L',
  kilometers: 'Km',
  hours: 'H',
  item: 'un',
  gram: 'g',
  cubic_meter: 'm³',
}

